/**
 * Password strength indicator utilities
 */
 
// ----------------------------------------------- constants
const STRENGTH_BAD = 'bad';
const STRENGTH_WEAK = 'weak';
const STRENGTH_GOOD = 'good';
const STRENGTH_STRONG = 'strong';
const STRENGTH_VERY_STRONG = 'very-strong';

// ----------------------------------------------- export
module.exports = function exports(config, translations) {

  const tests = {
    // ----- Password is too short
    check_1: function(value) {
      let next = true;
      let passed = false;
      if (value.length < config.weakMin) {
        passed = true;
        next = false;
      }

      return {
        strength: STRENGTH_BAD,
        message: translations.psiTryAnotherTooShort,
        next: next,
        passed: passed
      };
    },

    // ----- Password is on blacklist
    check_2: function(value) {
      let next = true;
      let passed = false;
      const blackList = config.blacklist; // Password is on blacklist
      if (blackList.indexOf(value) >= 0) {
        passed = true;
        next = false;
      }

      return {
        strength: STRENGTH_BAD,
        message: translations.psiTryPasswordNotAvailable,
        next: next,
        passed: passed
      };
    },

    // ----- Password is only numeric
    check_3: function(value) {
      let next = true;
      let passed = false;
      const re = new RegExp(`^[0-9]{${config.weakMin},}$`);
      if (re.test(value)) {
        passed = true;
        next = false;
      }

      return {
        strength: STRENGTH_WEAK,
        message: translations.psiWeakAddAlphaAndNumbers,
        next: next,
        passed: passed
      };
    },

    // ----- Password length is weak and is alphanumeric
    check_4: function(value) {
      let next = false;
      let passed = false;
      const re = new RegExp(`^.{${config.weakMin},}$`);
      if (re.test(value)) {
        passed = true;
        next = true;
      }

      return {
        strength: STRENGTH_WEAK,
        message: translations.psiWeakAddCapitalsAndNumbers,
        next: next,
        passed: passed
      };
    },

    // ----- Password length is weak and is alpha and same case
    check_5: function(value) {
      let next = false;
      let passed = false;
      const re = new RegExp(`^[a-z0-9\\W_|A-Z0-9\\W_]{${config.weakMin},}$`);
      if (re.test(value)) {
        passed = true;
        next = true;
      }

      return {
        strength: STRENGTH_WEAK,
        message: translations.psiWeakAddCapitalsAndNumbers,
        next: next,
        passed: passed
      };
    },

    // ----- Password length is strong and is alphanumeric mixed case with numbers OR wildcards
    check_6: function(value) {
      let next = false;
      let passed = false;
      let message = '';
      const re = new RegExp(`^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).{${config.goodMin},}$`);

      if (re.test(value)) {
        passed = true;
        next = true;
      }

      if (config.wildcards === undefined) {
        message = translations.psiGood;
      } else {
        message = translations.psiGood.replace('%wildcards%', config.wildcards);
      }

      return {
        strength: STRENGTH_GOOD,
        message: message,
        next: next,
        passed: passed
      };
    },

    // ----- Password length is strong and is alphanumeric mixed case with numbers OR wildcards
    check_7: function(value) {
      let next = false;
      let passed = false;
      const re = new RegExp(`^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9\\W_]).{${config.strongMin},}$`);
      if (re.test(value)) {
        passed = true;
        next = true;
      }

      return {
        strength: STRENGTH_STRONG,
        message: translations.psiStrong,
        next: next,
        passed: passed
      };
    },

    // ----- Password length is strong and is alphanumeric mixed case with numbers AND wildcards
    check_8: function(value) {
      let next = false;
      let passed = false;
      // eslint-disable-next-line max-len
      const re = new RegExp(`^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[\\W_]).{${config.strongMin},}$`);
      if (re.test(value)) {
        passed = true;
        next = true;
      }

      return {
        strength: STRENGTH_VERY_STRONG,
        message: translations.psiVeryStrong,
        next: next,
        passed: passed
      };
    }
  };

  return {
    /**
     * Get password validation test
     */
    getValidityLevel: function(value) {
      let lastTest = null;
      let test;

      for (const checkFn in tests) {
        if (tests.hasOwnProperty(checkFn) && typeof tests[checkFn] === 'function') {
          test = tests[checkFn](value);

          if (lastTest === null) {
            lastTest = test;
          }

          if (test.passed) {
            lastTest = test;
          }

          if (!test.next) {
            break;
          }
        }
      }

      return lastTest;
    },

    // checks
    check_1: tests.check_1,
    check_2: tests.check_2,
    check_3: tests.check_3,
    check_4: tests.check_4,
    check_5: tests.check_5,
    check_6: tests.check_6,
    check_7: tests.check_7,
    check_8: tests.check_8,

    // constants
    STRENGTH_BAD: STRENGTH_BAD,
    STRENGTH_WEAK: STRENGTH_WEAK,
    STRENGTH_GOOD: STRENGTH_GOOD,
    STRENGTH_STRONG: STRENGTH_STRONG,
    STRENGTH_VERY_STRONG: STRENGTH_VERY_STRONG
  };

};
